// One place for every contact detail the site shows.
export const PHONE_TEL = 'tel:+919476168969';
export const PHONE_DISPLAY = '+91 94761 68969';
export const WHATSAPP = 'https://wa.me/919476168969';
export const EMAIL = 'info@kalyaniconsultancy.com';
export const CRM_LOGIN = 'https://crm.kalyaniconsultancy.com/login';
export const UPI_ID = 'tusar.bera@okhdfcbank';
export const UPI_NAME = 'Kalyani Consultancy';
export const MAP_LINK = 'https://www.google.com/maps/search/?api=1&query=Akash+Ganga+Complex+Basudevpur+Haldia+721602';
export const MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d118310.09680908592!2d88.05908896585252!3d22.08053965944358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a02f7a9564a8681%3A0x81660e4b8c5c4444!2s5th%20Floor%2C%20Akash%20Ganga%20Complex%20Premises%20no%2C%205%2F4%2C%20Manjushree%2C%20Basudevpur%2C%20Haldia%2C%20West%20Bengal%20721602!3m2!1d22.0805603!2d88.1414906!5e0!3m2!1sen!2sin!4v1762307110832!5m2!1sen!2sin';

export const waLink = (text) => (text ? `${WHATSAPP}?text=${encodeURIComponent(text)}` : WHATSAPP);
